import {
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  createRecord,
  fetchList,
  updateRecord,
} from "../../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../../apis/ApiEndPoints";
import { toast } from "react-toastify";
import { Field, FieldArray, Formik } from "formik";
import FormikSelect from "../../../shared/material-ui-formik/FormikSelect";
import ConfirmDialog from "../../../shared/components/ConfirmDialog";
import Loader from "../../../layout/Loader";
import FormikInput1 from "../../../shared/material-ui-formik/FormikInput1";

const UpdateTaxPopup = (props) => {
  let { editedData, getReservationList, handleExtendDialogClose } = props;
  const { t } = useTranslation();
  const [hotelId, setHotelId] = useState(null);
  console.log(editedData, "editedData");
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("userDetails"));
    if (items) {
      setHotelId(items.hotel_id);
    }
  }, []);

  let id = editedData?.id;

  const [reservationRoomDetail, setReservationRoomDetail] = useState([]);
  const [reservationRateConditionDetail, setReservationRateConditionDetail] =
    useState({
      final_amount: 0,
      checkin_date: moment().format("YYYY-MM-DD"),
      checkout_date: moment().add(1, "days").format("YYYY-MM-DD"),
      season_id: 0,
    });
  const [isCorporateBooking, setIsCorporateBooking] = useState(0);
  const [selectedCorporate, setselectedCoporate] = useState(0);
  const [reservationStartAndEndDate, setReservationStartAndEndDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [loading, setLoading] = useState(false);
  const [bookingType, setBookingType] = useState(1);
  const [paymentType, setPaymentType] = useState(1);
  const [searchFilters, setSearchFilters] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(1, "days").format("YYYY-MM-DD"),
    noOfGuest: 2,
  });
  const [exemptTaxData, setExemptTaxData] = useState([]);
  const [guestInfo, setGuestInfo] = useState({
    user_id: 0,
    name: "",
    phone: "",
    phone_code: "+1",
    email: "",
    id_number: "",
    id_proof_type: "",
    id_proof: "",
    image: "",
    address: "",
    tax_exempt: 0,
    tat_id: "",
    iata_number: "",
    company_profile_name: "",
    corporate_id: 0,
    country_id: "",
    state_id: "",
    city_id: "",
    postal_code: "",
  });

  const getReservationDetails = async (data) => {
    if (+roomRateId !== +data?.bookingItemsData?.[0]?.room_rate_id) {
      setRoomRateId(data?.bookingItemsData?.[0]?.room_rate_id);
    }
    setReservationRoomDetail(data?.bookingItemsData);
    console.log(123, data);
    setReservationRateConditionDetail(data);
    setIsCorporateBooking(data?.is_corporate_booking);
    setselectedCoporate(data?.companyInfo?.id);
    // console.log(1823, data?.bookingItemsData[0]?.discountedRateInfo?.code + " - " + data?.bookingItemsData[0]?.discountedRateInfo?.name + " - " + data?.bookingItemsData[0]?.discountedRateInfo?.percentage + "%"  )
    setReservationStartAndEndDate({
      startDate: data?.checkin_date,
      endDate: data?.checkout_date,
    });
    setBookingType(data?.booking_type);
    setPaymentType(data?.payment_type);
    setSearchFilters((prevState) => ({
      ...prevState,
      startDate: data?.checkin_date,
      endDate: data?.checkout_date,
    }));
    if (data?.userData !== null) {
      let tax_data = [];
      if (data?.taxExemptionData?.length > 0) {
        const resultTax = await fetchList(
          ApiEndPoints.GET_TAXES + `?hotel_id=${hotelId}`,
        );
        if (resultTax.status == 200) {
          let tax_data =
            resultTax?.data?.filter((item) => {
              return data?.taxExemptionData?.some(
                (itm) => +item?.id == +itm?.tax_id,
              );
            }) || [];
          setExemptTaxData(tax_data);
          var exemptSum = 0;
          tax_data
            ?.filter((item) => +item?.tax_type === 1)
            ?.forEach((item) => {
              exemptSum += +item.tax_rate;
            });
          var exemptFlatSum = 0;
          tax_data
            ?.filter((item) => +item?.tax_type === 2)
            ?.forEach((item) => {
              exemptFlatSum += +item.tax_rate;
            });
          setTaxExemptRateData(exemptSum);
          setTaxExemptRateFlatData(exemptFlatSum);
        }
      }
      setGuestInfo({
        user_id: data?.userData?.userDetail?.user_id,
        name: data?.userData?.name,
        phone: data?.userData?.mobile,
        phone_code: data?.userData?.phone_code,
        email: data?.userData?.email,
        id_number: data?.userData?.idNumber,
        id_proof_type: data?.userData?.id_proof_type,
        id_proof: data?.userData?.id_proof,
        image: data?.userData?.image,
        address: data?.userData?.address,
        tax_exempt: data?.is_tax_exempt,
        tat_id: "",
        iata_number: data?.iata_number,
        company_profile_name: data?.groupMasterInfo?.company_profile_name,
        corporate_id: data?.groupMasterInfo?.corporate_id,
        country_id: data?.userData?.userDetail?.country_id,
        state_id: data?.userData?.userDetail?.state_id,
        city_id: data?.userData?.userDetail?.city_id,
        postal_code: data?.userData?.userDetail?.postal_code,
        tax_id_data: tax_data,
      });
    }
  };

  useEffect(() => {
    if (hotelId) {
      getReservationDetails(editedData);
    }
  }, [editedData, hotelId]);

  const [bookingRates, setBookingRates] = useState([]);
  const [roomRateId, setRoomRateId] = useState(0);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [calcuLoading, setCalcuLoading] = useState(false);
  const [taxRateData, setTaxRateData] = useState(0);
  const [taxRateFlatData, setTaxRateFlatData] = useState(0);

  const [searchTaxResult, setSearchTaxResult] = useState([]);
  const [taxExemptRateData, setTaxExemptRateData] = useState(0);
  const [taxExemptRateFlatData, setTaxExemptRateFlatData] = useState(0);


  const [cancelPolicy, setCancelPolicy] = useState(1);
  const [bookingDetails, setBookingDetails] = useState([]);
  const bookingDetailsInitialState = {
    bookingDetailsInfo: bookingDetails,
  };

  const [bookingDetailsStats, setBookingDetailsStats] = useState({
    noOfRooms: 0,
    noOfAdults: 0,
    noOfChild: 2,
    totalAmount: 0,
    discountedTotal: 0,
    taxAmount: 0,
    totalTax: 0,
    addOnTotal: 0,
    finslTotal: 0,
    extraAdult: 0,
    extraChild: 0,
    packageTotal: 0,
  });

  const [selectedTax, setSelectedTax] = useState([]);

  useEffect(() => {
    var date1 = moment(searchFilters.startDate);
    var date2 = moment(searchFilters.endDate);
    var dayDiff = date2.diff(date1, "days");
    var noOfRoom = 0;
    var noOfAdults = 0;
    var noOfExtraAdult = 0;
    var noOfChild = 0;
    var noOfExtraChild = 0;
    var totalAmount = 0;
    var discountedTotal = 0;
    var addOnTotal = 0;
    var packageTotal = 0;
    var finslTotal = 0;
    var extraAdult = 0;
    var extraChild = 0;
    var taxAmount = 0;
    var totalTax = 0;
    let taxList = [];
    bookingDetails.forEach((item) => {
      noOfRoom += item.roomQty;
      noOfAdults += +item?.noOfAdult + +item?.noOfDefaultAdult;
      noOfChild += +item?.noOfChild + +item?.noOfDefaultChild;
      noOfExtraAdult += item?.noOfAdult;
      noOfExtraChild += item?.noOfChild;
      totalAmount += item.roomQty * item.price;
      discountedTotal += +item.discountOnePrice;
      addOnTotal += +item.addOnPrice;
      packageTotal += +item.packageTotal;
      extraAdult += +item.discountAdult;
      extraChild += +item.discountChild;
      totalTax =
        ((+totalAmount +
          +extraAdult +
          +addOnTotal +
          +extraChild -
          +discountedTotal +
          +packageTotal) /
          100) *
          Number(taxRateData) +
        dayDiff * +taxRateFlatData;
      finslTotal =
        Number(totalAmount) +
        Number(extraAdult) +
        extraChild -
        discountedTotal +
        +packageTotal +
        totalTax;
    });

    for (var j in exemptTaxData) {
      if (+exemptTaxData[j]?.tax_type === 1) {
        taxList.push({
          tax_exempt_id: exemptTaxData[j].id,
          tax_exempt_amount:
            ((totalAmount +
              extraAdult +
              addOnTotal +
              +packageTotal +
              extraChild -
              discountedTotal) /
              100) *
            exemptTaxData[j].tax_rate,
          tax_type: exemptTaxData[j].tax_type,
        });
      }
      if (+exemptTaxData[j]?.tax_type === 2) {
        taxList.push({
          tax_exempt_id: exemptTaxData[j].id,
          tax_exempt_amount: +exemptTaxData[j].tax_rate,
          tax_type: exemptTaxData[j].tax_type,
        });
      }
    }

    // console.log("totalTax:", totalTax, "finslTotal:", finslTotal,"exmptTaxData:", exemptTaxData , "selected tax:", taxList , 135 )

    setSelectedTax(taxList);
    var sum = 0;
    taxList.forEach((item) => {
      sum +=
        +item?.tax_type === 1
          ? +item?.tax_exempt_amount
          : +item?.tax_exempt_amount * dayDiff;
    });

    setBookingDetailsStats((prev) => ({
      ...prev,
      noOfRooms: noOfRoom,
      noOfAdults: noOfAdults,
      noOfChild: noOfChild,
      noOfExtraAdult: noOfExtraAdult,
      noOfExtraChild: noOfExtraChild,
      totalAmount: totalAmount,
      addOnTotal: addOnTotal,
      extraAdult: extraAdult,
      extraChild: extraChild,
      taxAmount: sum,
      packageTotal: packageTotal,
      discountedTotal: discountedTotal,
      totalTax: totalTax - sum < 0 ? 0 : totalTax - sum,
      finslTotal: finslTotal + addOnTotal - (totalTax - sum < 0 ? 0 : sum),
    }));
  }, [bookingDetails]);

  // Room Number
  const [selectedRoom, setSelectedRoom] = useState([]);
  const [openSendSmsEmailDialog, setOpenSendSmsEmailDialog] = useState(false);
  const handleRoomNumber = (e, setFieldValue, indexs, data) => {
    const data1 = bookingDetailsInitialState?.bookingDetailsInfo?.find(
      (item, index) => index === indexs,
    );
    const data2 = bookingDetailsInitialState?.bookingDetailsInfo?.filter(
      (item, index) => item.roomType === data1.roomType,
    );
    data1.roomNo = e.target.value;
    const selectedRooms = [];

    for (var j in data2) {
      if (data2[j].roomNo !== 0) {
        selectedRooms.push(data2[j].roomNo);
      }
      setSelectedRoom(selectedRooms);
    }

    for (var t in selectedRoom) {
      if (selectedRoom[t] === e.target.value) {
        data1.roomNo = 0;
        setFieldValue(`bookingDetailsInfo.${indexs}.roomNo`, 0);
        toast.error(
          ` This Room is Already selected for this Romm Type ${data?.roomType}`,
        );
        return;
      } else {
        data1.roomNo = e.target.value;
        setFieldValue(`bookingDetailsInfo.${indexs}.roomNo`, e.target.value);
      }
    }
  };

  useEffect(() => {
    if (hotelId && id) {
      // getTaxMaster("test");
      getAllTaxList();
    }
  }, [hotelId, id]);

  const getAllTaxList = async () => {
    const result = await fetchList(
      ApiEndPoints.GET_TAXES + `?hotel_id=${hotelId}`,
    );
    // console.log(result, 1790)
    if (result?.status === 200) {
      // setTaxRateData(result.data);
      setTaxRateData(
        result.data
          ?.filter((item) => +item?.tax_type === 1)
          ?.reduce((n, { tax_rate }) => n + +tax_rate, 0),
      );
      setTaxRateFlatData(
        result.data
          ?.filter((item) => +item?.tax_type === 2)
          ?.reduce((n, { tax_rate }) => +n + +tax_rate, 0),
      );

      const intersection = result.data.filter(
        (element) =>
          !searchTaxResult.map((item) => item.id).includes(element.id),
      );
      setSearchTaxResult(intersection);
    } else {
      setTaxRateData(0);
      setTaxRateFlatData(0);
      setSearchTaxResult([]);
    }
  };

  const createBooking = async (send_sms) => {
    setOpenSendSmsEmailDialog(false);
    if (bookingDetailsInitialState?.bookingDetailsInfo?.length == 0) {
      toast.error(
        t(
          "To confirm the Edit reservation, you must select at least one room in the first step",
        ),
      );
      return;
    }

    if (guestInfo.name == "") {
      toast.error(
        t(
          "To confirm the Edit reservation, you must Add User in the Second step",
        ),
      );
      return;
    }

    if (!guestInfo.name?.includes(" ")) {
      toast.error(
        t(
          "To confirm the reservation, you must add last name in the Second step",
        ),
      );
      return;
    }

    if (!guestInfo.name?.includes(" ")) {
      toast.error(
        t(
          "To confirm the reservation, you must add last name in the Second step",
        ),
      );
      return;
    }

    for (var j in bookingDetailsInitialState?.bookingDetailsInfo) {
      if (bookingDetailsInitialState?.bookingDetailsInfo[j].roomNo === 0) {
        toast.error(
          t("To confirm the Edit reservation, you must select Room Number"),
        );
        return;
      }

      if (
        bookingDetailsInitialState?.bookingDetailsInfo[j].discounted_rate_id !=
          bookingDetailsInitialState?.bookingDetailsInfo[j]
            .discounted_selected &&
        bookingDetailsInitialState?.bookingDetailsInfo[j].discount_comment ===
          ""
      ) {
        toast.error(
          t("To confirm the Edit reservation, you must write Discount Comment"),
        );
        return;
      }
    }

    var userData = new FormData();
    userData.append("name", guestInfo?.name);
    userData.append("phone", guestInfo?.phone);
    userData.append("email", guestInfo?.email);
    userData.append("id_number", guestInfo?.id_number);
    userData.append("id_proof_type", guestInfo?.id_proof_type);
    // userData.append("id_proof", guestInfo?.id_proof);
    userData.append("address", guestInfo?.address);
    userData.append("phone_code", guestInfo?.phone_code);
    userData.append("country", guestInfo?.country_id);
    userData.append("state", guestInfo?.state_id);
    userData.append("city", guestInfo?.city_id);
    userData.append("pin_code", guestInfo?.postal_code);
    setLoading(true);
    const result = await createRecord(userData, ApiEndPoints.ADD_USER);
    if (result?.status === 200) {
      const roomItems = bookingDetailsInitialState?.bookingDetailsInfo?.map(
        (item, index) => {
          return {
            booking_item_id: item.bookeng_item_id || 0,
            room_category_id: item.roomTypeId,
            number_of_room: 1,
            no_of_adults:
              item?.noOfDefaultAdult === "" ? 0 : item?.noOfDefaultAdult,
            no_of_extra_adults: item?.noOfAdult,
            no_of_children:
              item?.noOfDefaultChild === "" ? 0 : item?.noOfDefaultChild,
            no_of_extra_children: item?.noOfChild,
            no_of_pets: 0,
            including_meal: 0,
            room_rate_id: item.rateId,
            room_no: item.roomNo,
            discounted_rate_id: String(item?.discounted_selected)?.includes("-")
              ? 0
              : Math.trunc(+item.discounted_selected),
            // +item.discount_type === 1 ? Math.trunc(+item.discounted_selected) : 0,
            discount_comment: item.discount_comment,
            discount_type: item.discount_type,
            discount: item.discountOnePrice,
            addons: item.withMeal,
            discount_percentage: item.discount_percentage,
            extra_adult_rate: item?.extra_adult_rate,
            extra_child_rate: item?.extra_child_rate,
            two_adult_rate: item?.two_adult_rate,
            is_custom_price:
              +item?.extra_adult_rate ===
                +item?.compare_price?.onlyExtraAdult &&
              +item?.extra_child_rate ===
                +item?.compare_price?.onlyExtraChild &&
              +item?.two_adult_rate === +item?.compare_price?.price
                ? 0
                : 1,
            room_rate: item?.compare_price?.multiRate,
            packageList: item?.packageList || [],
          };
        },
      );

      let bookingData = {
        user_id: result.data.id,
        hotel_id: hotelId,
        booking_type: bookingType,
        payment_type: paymentType,
        token: "",
        credit_card_id: "",
        bank_name: "",
        iata_number: "",
        no_of_adults: bookingDetailsStats.noOfAdults,
        no_of_children: bookingDetailsStats.noOfChild,
        no_of_pets: 0,
        no_of_extra_persons: 0,
        is_tax_exempt: guestInfo.tax_exempt,
        guarantee_policy: 1,
        cancel_policy: bookingDetailsInitialState?.bookingDetailsInfo?.[0]?.cancelationPolicyId,
        // checkin_date: searchFilters.startDate,
        checkin_date: moment(searchFilters.startDate).format("YYYY-MM-DD"),
        checkout_date: moment(searchFilters.endDate).format("YYYY-MM-DD"),
        room_details: roomItems,
        season_id: reservationRateConditionDetail?.season_id,
        tax_exempt_data: selectedTax,
        deleted_room_item: [],
        send_sms: send_sms,
        is_corporate_booking: isCorporateBooking,
        corporate_company_id: isCorporateBooking === 1 ? selectedCorporate : 0,
      };
      const bookingResult = await updateRecord(
        bookingData,
        parseInt(id),
        ApiEndPoints.CREATE_BOOKING,
      );
      if (bookingResult?.status === 200) {
        setLoading(false);
        toast.success(t(bookingResult.message));
        handleExtendDialogClose();
        getReservationList();
      } else {
        setLoading(false);
        toast.error(t(bookingResult.message));
      }
    } else {
      setLoading(false);
      toast.error(t(result.message));
    }
  };

  useEffect(() => {
    if (hotelId && id && roomRateId) {
      EditReser();
    }
  }, [
    reservationRoomDetail,
    roomRateId,
    searchFilters,
    taxRateData,
    hotelId,
    id,
  ]);
  console.log(roomRateId, "roomRateId");

  async function EditReser() {
    var date1 = moment(searchFilters.startDate);
    var date2 = moment(searchFilters.endDate);
    var dayDiff = date2.diff(date1, "days");
    let newBookingRate = [];

    var date1 = moment(searchFilters.startDate);
    var date2 = moment(searchFilters.endDate);
    var days = date2.diff(date1, "days");
    let room_detail = [];
    const selectedRooms = [];
    // let roomRateNameFetch = reservationRateConditionDetail?.season_id
    // console.log(reservationRateConditionDetail?.season_id, 4842);
    setLoading(true);
    let bookRoomRateId = 0;
    if (reservationRoomDetail?.length > 0) {
      bookRoomRateId = reservationRoomDetail[0]?.room_rate_id;
      if (+roomRateId !== +bookRoomRateId) {
        setRoomRateId(reservationRoomDetail[0]?.room_rate_id);
      }
    }

    let pkgData = reservationRateConditionDetail?.bookingPackages;

    if (reservationRoomDetail !== null) {
      for (var j in reservationRoomDetail) {
        selectedRooms.push(reservationRoomDetail[j]?.room_no);
        if (
          searchFilters?.endDate === reservationStartAndEndDate?.endDate &&
          searchFilters?.startDate === reservationStartAndEndDate?.startDate
        ) {
          let packagePerNight = 0;
          let packageOneTime = 0;
          let packagePerPerson = 0;
          let packageLists = [];
          if (pkgData?.length > 0) {
            pkgData.forEach((pkg) => {
              let by_date = pkg?.bookingPackagesDates?.map((pk) => ({
                ...pk,
                charge_type: pkg?.charge_type,
              }));
              if (+pkg?.charge_type === 1) {
                packagePerNight += +pkg.unit_price;
              }
              if (+pkg?.charge_type === 2) {
                packageOneTime += +pkg.unit_price;
              }
              if (+pkg?.charge_type === 3) {
                packagePerPerson += +pkg.unit_price;
              }
              packageLists.push({
                name: pkg?.packageInfo?.name,
                // amount: pkg?.price,
                id: pkg?.package_id,
                unit_price: pkg?.unit_price,
                total_amount: pkg?.total_amount,
                charge_type: pkg?.charge_type,
                by_date: by_date,
              });
            });
          }

          let packagePerPersonAmount =
            +packagePerPerson *
            (+reservationRoomDetail[j].no_of_extra_adults +
              +reservationRoomDetail[j].no_of_adults +
              +reservationRoomDetail[j].no_of_extra_children +
              +reservationRoomDetail[j].no_of_children);

          room_detail.push({
            data: {
              discount_percentage:
                reservationRoomDetail[j].discounted_rate_id === 0
                  ? +reservationRoomDetail[j]?.discount_percentage
                  : reservationRoomDetail[j].discountedRateInfo
                    ? reservationRoomDetail[j].discountedRateInfo?.percentage
                    : 0,
              discountType: +reservationRoomDetail[j].discount_type,
              discount: +reservationRoomDetail[j]?.discount,
              rateDetails: newBookingRate?.find(
                (elf) =>
                  +elf?.id ===
                  +reservationRoomDetail[j]?.roomCategoryDetail?.id,
              )?.rateDetails,
              RoomQuantity: 1,
              rateId: reservationRoomDetail[j].room_rate_id,
              selectAdult: reservationRoomDetail[j].no_of_extra_adults,
              selectChild: reservationRoomDetail[j].no_of_extra_children,
              defaultSelectedRateId: "",
              addOnTotal: +reservationRoomDetail[j].addon_total,
              addOnPrice: +reservationRoomDetail[j].addon_total,
              packagePerNight: packagePerNight,
              packageOneTime: packageOneTime,
              packagePerPerson: packagePerPerson,
              packageList: packageLists,
              packagesOption: packageLists?.map((pk) => pk.id) || [],
              mealPrice: reservationRoomDetail[j].meal_price,
            },
            bookeng_item_id: reservationRoomDetail[j].id,
            roomQty: reservationRoomDetail[j].room_quantity,
            noOfAdult: reservationRoomDetail[j].no_of_extra_adults,
            noOfDefaultAdult: reservationRoomDetail[j].no_of_adults,
            noOfChild: reservationRoomDetail[j].no_of_extra_children,
            noOfDefaultChild: reservationRoomDetail[j].no_of_children,

            min_adult: reservationRoomDetail[j].no_of_adults,
            noOfExtraAdult: reservationRoomDetail[j].no_of_extra_adults,
            startDate: searchFilters.startDate,
            endDate: searchFilters.endDate,
            nights: days,
            roomRateName:
              newBookingRate[0]?.rateDetails?.length > 0
                ? newBookingRate[0]?.rateDetails?.find(
                    (el) => +el?.category_rate_type_id === +bookRoomRateId,
                  )?.name
                : 0,
            rateId: reservationRoomDetail[j].room_rate_id,
            compare_price: {
              onlyExtraAdult: +reservationRoomDetail[j].extra_adult_price,
              onlyExtraChild: +reservationRoomDetail[j].child_price,
              price: +reservationRoomDetail[j].room_price,
              multiRate: [],
            },
            extra_adult_rate: +reservationRoomDetail[j].extra_adult_price,
            extra_child_rate: +reservationRoomDetail[j].child_price,
            two_adult_rate: +reservationRoomDetail[j].room_price,
            discountAdult:
              reservationRoomDetail[j].no_of_extra_adults !== 0
                ? +(
                    +days *
                    reservationRoomDetail[j].extra_adult_price *
                    reservationRoomDetail[j].no_of_extra_adults
                  ).toFixed(2)
                : "0.00",
            discountChild:
              reservationRoomDetail[j].no_of_extra_children !== 0
                ? +(
                    +days *
                    reservationRoomDetail[j].child_price *
                    reservationRoomDetail[j].no_of_extra_children
                  ).toFixed(2)
                : "0.00",
            discountedPrice:
              reservationRoomDetail[j].discount !== "0.00"
                ? +(
                    +days * reservationRoomDetail[j].room_price -
                    reservationRoomDetail[j].discount
                  ).toFixed(2)
                : "0.00",
            discountedTotalPrice: +reservationRoomDetail[j]?.final_amount,
            discountedTotalPriceWithTax: +(
              (Number(reservationRoomDetail[j]?.final_amount) / 100) *
                (Number(taxRateData) - Number(taxExemptRateData)) +
              dayDiff * (+taxRateFlatData - taxExemptRateFlatData) +
              Number(reservationRoomDetail[j]?.final_amount)
            ).toFixed(2),
            discountPrice: reservationRoomDetail[j].subtotal,
            totalRateOfRoom: reservationRoomDetail[j]?.final_amount,
            totalRateWithTax: +(
              (Number(reservationRoomDetail[j]?.final_amount) / 100) *
                (Number(taxRateData) - Number(taxExemptRateData)) +
              dayDiff * (+taxRateFlatData - taxExemptRateFlatData) +
              Number(reservationRoomDetail[j]?.final_amount)
            ).toFixed(2),

            // price: reservationRoomDetail[j]?.room_price,
            AvgPricePerRoom: reservationRoomDetail[j]?.room_price,
            price: +days * reservationRoomDetail[j].room_price,
            discount_type: reservationRoomDetail[j].discount_type,
            discount: reservationRoomDetail[j].discount,
            discountValue: 0,
            addOnTotal: reservationRoomDetail[j].addon_total,
            addOnPrice: reservationRoomDetail[j].addon_total,
            packagePerNight: packagePerNight,
            packageOneTime: packageOneTime,
            packagePerPerson: packagePerPerson,
            packageList: packageLists,
            packagesOption: packageLists?.map((pk) => pk.id) || [],
            packageTotal:
              +(+days * packagePerNight) +
              packageOneTime +
              packagePerPersonAmount,
            discountOnePrice: reservationRoomDetail[j].discount,
            discounted_rate: reservationRoomDetail[j]?.discountedRateInfo
              ? reservationRoomDetail[j]?.discountedRateInfo?.code +
                " - " +
                reservationRoomDetail[j]?.discountedRateInfo?.name +
                " - " +
                reservationRoomDetail[j]?.discountedRateInfo?.percentage +
                "%"
              : "No Discount Rate",
            mealPrice: reservationRoomDetail[j].meal_price,
            discounted_selected:
              reservationRoomDetail[j].discounted_rate_id === 0 &&
              +reservationRoomDetail[j].discount_type === 2
                ? "F-" + (+reservationRoomDetail[j].discount).toFixed(2)
                : +reservationRoomDetail[j].discounted_rate_id === 0
                  ? "-" + +reservationRoomDetail[j].discount_percentage
                  : reservationRoomDetail[j].discounted_rate_id,
            discount_percentage:
              reservationRoomDetail[j].discounted_rate_id === 0
                ? +reservationRoomDetail[j]?.discount_percentage
                : reservationRoomDetail[j].discountedRateInfo
                  ? reservationRoomDetail[j].discountedRateInfo?.percentage
                  : 0,
            cancelationPolicy:
              reservationRoomDetail[j]?.roomCategoryRateType
                ?.cancellationPolicyDetails?.name,
            cancelationPolicyId:
              reservationRoomDetail[j]?.roomCategoryRateType
                ?.cancellationPolicyDetails?.id,
            discounted_rate_id: reservationRoomDetail[j].discounted_rate_id,
            roomType:
              reservationRoomDetail[j]?.roomCategoryDetail?.roomcategory_name,
            roomTypeId: reservationRoomDetail[j]?.roomCategoryDetail?.id,
            roomNo: reservationRoomDetail[j]?.room_no,
            availableRooms: [
              {
                id: reservationRoomDetail[j]?.room_no,
                room_name: reservationRoomDetail[j]?.roomDetail?.room_name,
              },
            ],
            withMeal: reservationRoomDetail[j].bookingAddonDetail,
            reservationRoomDetail: reservationRoomDetail[j],
            newBookingRate: newBookingRate,
            mealOption: reservationRoomDetail[j].bookingAddonDetail?.map(
              (item) => item?.addonDetail?.name,
            ),
            discount_comment: "",
            discount_Edit: true,
            old_price: true,
            edited_room: true,
          });
        }

        // console.log(searchFilters?.endDate ===  reservationStartAndEndDate?.endDate && searchFilters?.startDate === reservationStartAndEndDate?.startDate , 2679)
      }
      setSelectedRoom(selectedRooms);

      // totalRateOfRoom = dayDiff * roomListDet[i]?.discountPrice
      setLoading(false);
      setBookingDetails(room_detail);
    } else {
      setLoading(false);
    }
  }

  return (
    <div className="p-2">
      {(loading || bookingLoading || calcuLoading) && <Loader />}
      <Grid container spacing={1}>
        <Grid item md={4} xs={6}>
          <Typography
            id="font-600"
            style={{
              marginBottom: "11px",
              color: "rgb(30, 30, 30)",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "500 !important",
            }}
          >
            {t("Booking Id")}
          </Typography>
          <TextField
            value={`#${String(editedData?.id).padStart(6, "0")}`}
            disabled
          />
        </Grid>
        <Grid item md={4} xs={6}>
          <Typography
            id="font-600"
            style={{
              marginBottom: "11px",
              color: "rgb(30, 30, 30)",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "500 !important",
            }}
          >
            {t("Guest Name")}
          </Typography>
          <TextField value={editedData?.userData?.name} disabled />
        </Grid>
      </Grid>
      <Formik
        initialValues={bookingDetailsInitialState}
        onSubmit={() => {}}
        validateOnBlur={false}
        validateOnChange={true}
        enableReinitialize={true}
      >
        {(props) => {
          const { handleSubmit } = props;
          return (
            <form onSubmit={handleSubmit} noValidate>
              <FieldArray name="rooms_info">
                {({ push, remove }) => (
                  <Fragment>
                    {props.values?.bookingDetailsInfo?.map((data, index) => (
                      <Fragment key={index}>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              marginBottom: "15px",
                              borderTop: "2px solid",
                              marginTop: "15px",
                            }}
                          ></div>
                          <Grid container spacing={2}>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Room Type")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.roomType}
                              </Typography>
                            </Grid>

                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Dates")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {moment(data.startDate).format("ll")} -{" "}
                                {moment(data.endDate).format("ll")}
                              </Typography>
                            </Grid>

                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Nights")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.nights}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Room rate")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.roomRateName}
                              </Typography>
                            </Grid>

                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Cancellation policy")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.cancelationPolicy}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Quantity")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.roomQty}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Avg. Price/Room")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data?.AvgPricePerRoom}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Add On Price")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.addOnPrice}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Package Price")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data?.packageTotal
                                  ? data?.packageTotal.toFixed(2)
                                  : 0}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Extra Adult")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.noOfAdult}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Extra Child")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.noOfChild}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Extra Adult Price")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.discountAdult}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Extra Child Price")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.discountChild}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Discount")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {(+data.discount).toFixed(2)}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Total Price")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.discountedTotalPrice}
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={4} sm={6} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Total Price With Tax")}
                              </Typography>
                              <Typography variant="subtitle2">
                                {data.discountedTotalPriceWithTax}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={2}
                              md={4}
                              sm={6}
                              xs={12}
                              style={{
                                paddingRight: "5px",
                              }}
                            >
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "#8A92A6",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Room Number")}
                              </Typography>
                              <Field
                                name={`bookingDetailsInfo.${index}.roomNo`}
                                onChange={(e) => {
                                  handleRoomNumber(
                                    e,
                                    props.setFieldValue,
                                    index,
                                    data,
                                  );
                                }}
                                defaultOption
                                options={data?.availableRooms?.map(
                                  (item, index) => ({
                                    title: item?.room_name,
                                    value: item?.id,
                                  }),
                                )}
                                disabled
                                component={FormikSelect}
                              />
                            </Grid>

                            {data.discounted_rate_id !=
                              data.discounted_selected && (
                              <Grid item lg={11} md={11} sm={11} xs={12}>
                                <Field
                                  label={t("Comment")}
                                  type="text"
                                  name={`bookingDetailsInfo.${index}.discount_comment`}
                                  placeHolder={t("Write Comment")}
                                  onBlur={async (e) => {
                                    setBookingDetails(
                                      bookingDetails.map((obj) => {
                                        if (
                                          obj.bookeng_item_id ===
                                          data.bookeng_item_id
                                        ) {
                                          return {
                                            ...obj,
                                            discount_comment: e.target.value,
                                          };
                                        } else {
                                          return obj;
                                        }
                                      }),
                                    );
                                  }}
                                  // maxLength={150}
                                  component={FormikInput1}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      </Fragment>
                    ))}
                  </Fragment>
                )}
              </FieldArray>
            </form>
          );
        }}
      </Formik>
      <div
        className="w-100 mt-2 d-flex justify-content-end"
        style={{ flexFlow: "row wrap", flexShrink: "0" }}
      >
        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Room Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.totalAmount.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Child Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.extraChild.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Adult Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.extraAdult.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Discount Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.discountedTotal.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Add-On Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.addOnTotal.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1">
          {t("Package Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats?.packageTotal.toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1">
          {t("Sub Total")} :{" "}
          <span id="font-500">
            $
            {(
              Number(bookingDetailsStats.finslTotal) -
              Number(bookingDetailsStats.totalTax)
            ).toFixed(2)}
          </span>
        </h5>
        <h5 className="mr-2 mt-1">
          {t("Exempt Tax Total")} :{" "}
          <span id="font-500">${bookingDetailsStats.taxAmount.toFixed(2)}</span>
        </h5>
        <h5 className="mr-2 mt-1">
          {t("Previous Tax Total")} :{" "}
          <span id="font-500">${(+reservationRateConditionDetail?.total_tax).toFixed(2)}</span>
        </h5>
        <h5 className="mr-2 mt-1">
          {t("Current Tax Total")} :{" "}
          <span id="font-500">${bookingDetailsStats.totalTax.toFixed(2)}</span>
        </h5>

        <h5 className="mr-2 mt-1" style={{ fontSize: "16px" }}>
          {t("Final Total")} :{" "}
          <span id="font-500">
            ${bookingDetailsStats.finslTotal.toFixed(2)}
          </span>
        </h5>
      </div>
      <div
        className={`w-100 d-flex py-2 justify-content-between align-items-center`}
        style={{
          background: "#F2F2F2",
          border: "1px solid #B4ADAD",
          boxShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "8px",
          alignContent: "center",
          marginTop: "20px",
          flexFlow: "row wrap",
          flexShrink: "0",
          gap: "10px",
        }}
      >
        <div>
          <div
            className="w-100 h-100 ml-2 d-flex align-items-center"
            style={{
              color: "#244264",
              flexFlow: "row wrap",
              flexShrink: "0",
            }}
          >
            <h5 className="mr-2 " style={{ fontSize: "20px" }}>
              <span id="font-600"> {t("Current Total")} </span> : $
              {bookingDetailsStats?.finslTotal.toFixed(2)}
            </h5>
            <h5 className="mr-2 " style={{ fontSize: "20px" }}>
              <span id="font-600">{t("Previous Total")}</span>: $
              {reservationRateConditionDetail?.final_amount}
            </h5>
            <h5 className="mr-2 " style={{ fontSize: "20px" }}>
              <span id="font-600">{t("Total Difference")} </span>:{" "}
              {+bookingDetailsStats.finslTotal -
                +reservationRateConditionDetail?.final_amount <
              0
                ? "-"
                : ""}{" "}
              $
              {Math.abs(
                +bookingDetailsStats.finslTotal -
                  +reservationRateConditionDetail?.final_amount,
              ).toFixed(2)}
            </h5>
          </div>
        </div>
        <div className="mx-2">
          <Button
            variant="contained"
            onClick={() => setOpenSendSmsEmailDialog(true)}
            title="Cancel"
            style={{ width: "157px", height: "57px" }}
          >
            {t("Update Booking")}
          </Button>
        </div>
      </div>
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to send sms/email to the user?")}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes")}
        openDialog={openSendSmsEmailDialog}
        handleDialogCloseAction={() => createBooking(0)}
        handleDialogClose={() => setOpenSendSmsEmailDialog(false)}
        handleDialogAction={() => createBooking(1)}
      />
    </div>
  );
};

export default UpdateTaxPopup;
